import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-sustainability-chart',
  templateUrl: './sustainability-chart.component.html',
  styleUrls: ['./sustainability-chart.component.scss']
})
export class SustainabilityChartComponent implements OnInit {
  formattedData: { modeLabel: string; carbon: number; year: string; month: string }[] = [];

  barChartData: { name: string; value: number }[] = [];
  colorScheme = {
    domain: ['#4CAF50', '#81C784', '#388E3C']
  };

  constructor(
    private cdr: ChangeDetectorRef,
    
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.formattedData = this.data.formattedData;
    this.updateChart();
    this.cdr.detectChanges();
  }

  updateChart(): void {
    const totalCarbonPermonth: { [key: string]: number } = {};

    for (const entry of this.formattedData) {
      // if (isNaN(entry.carbon) || entry.carbon === null || entry.carbon === undefined) {
      //   continue;
      // }

      const key = `${entry.year}-${entry.month}`;
      totalCarbonPermonth[key] = (totalCarbonPermonth[key] || 0) + entry.carbon;
    }

    this.barChartData = Object.entries(totalCarbonPermonth).map(([month, total]) => ({
      name: month,
      value: total
    }));

    this.cdr.detectChanges();
  }
}
